// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"173":"2dcbd3b7","525":"1a2adcaa"}[chunkId] + ".chunk.js";
};